/**
 * `#connectors` — `template.html` dòng 974–993.
 *
 * Tám ô, đúng thứ tự thiết kế (:982-989). Tên sản phẩm KHÔNG dịch, nên `tiles` giống hệt nhau ở
 * hai locale — vẫn khai ở cả hai vì `type Copy = typeof vi` đòi bản `en` phủ đủ khoá.
 */

const tiles: readonly string[] = [
  'Snowflake',
  'GitLab',
  'Linear',
  'Google Drive',
  'Jira',
  'Figma',
  'PostgreSQL',
  'Webhook / API',
];

export const connectors = {
  eyebrow: 'Tích hợp',
  /*
   * CẢNH BÁO — CHUỖI NÀY ĐANG CHẠM MÉP. Đo ở 1440px: h2 xuống 2 dòng, dòng 2 rộng 528.5px trong cột
   * rộng 529.2px — tức 99.9%. Thêm một chữ là sang 3 dòng, và mọi thứ dưới nó tụt ~46px.
   *
   * Sửa chuỗi này thì ĐO LẠI trước khi commit:
   *   pnpm --filter @nexa/web build
   *   pnpm --filter @nexa/web design:diff -- --section '#connectors'
   * Đọc số dòng của h2 ở CẢ HAI phía, đừng đọc mỗi bề rộng.
   *
   * Bản `en` không có rủi ro này (dòng 2 chỉ 409px/529px).
   */
  heading: 'Kết nối những hệ thống công việc vốn đã nằm ở đó.',
  lead: 'Nguồn dữ liệu và công cụ được gắn theo workspace hoặc theo dự án, nên agent chỉ nhìn thấy đúng phạm vi dự án được phép.',
  tiles,
};
